<script setup lang="ts">
import unexpectedEventsAndLongTimeContinuousDrivingExtensions from "src/types/responses/unexpectedEventsAndLongTimeContinuousDrivingExtensions";
import ModalFlashMessage from "@/components/Common/ModalFlashMessage.vue";
import { useAuth } from "@/services/user/Auth0UserProvider";
import Api from "@/services/api/ApiServiceFabrick";
import { ref, reactive, computed } from 'vue';
import { GDialog } from 'gitart-vue-dialog';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue'])

const props = defineProps<{
  deleteItem: unexpectedEventsAndLongTimeContinuousDrivingExtensions,
  getUnexpectedEventAndLongTimeDrivingExtensions: () => void
  modelValue: boolean,
  showFlash: (message: string, type: string, fadeout: boolean) => {value: any}
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

type flashMessagesType = {
  message: string,
  show: boolean,
  type: string,
  cancel: boolean
}

const flashMessage = reactive({
  message: "",
  show: false,
  type: "info",
  cancel: false
}) as flashMessagesType

const { loginWithRedirect } = useAuth()
const isLoading = ref(false)

const isUnexpectedEvents = computed(() => {
  return props.deleteItem.division_name == 'unexpected_events'
})

const confirmMessage = computed(() => {
  if (isUnexpectedEvents.value) return i18n.global.t('pages.unexpectedEventAndAlertStatuses.deleteModal.unexpectedEvent.note')
  return i18n.global.t('pages.unexpectedEventAndAlertStatuses.deleteModal.longTimeContinuousDrivingExtension.note')
})

function closeModal(isDeleted: boolean) {
  if (isDeleted) props.getUnexpectedEventAndLongTimeDrivingExtensions()
  modelValue.value = false
}

function handleDelete() {
  isLoading.value = true
  if (isUnexpectedEvents.value) return deleteUnexpectedEvent()
  return deleteLongTimeContinuousDrivingExtension()
}

function deleteUnexpectedEvent() {
  Api().deleteUnexpectedEvent(props.deleteItem.id).then(() => {
    successDelete()
  }).catch((error: any) => {
    isLoading.value = false
    return errorHandle(error.response)
  })
}

function deleteLongTimeContinuousDrivingExtension() {
  Api().deleteLongTimeContinuousAlerts(props.deleteItem.id).then(() => {
    successDelete()
  }).catch((error: any) => {
    isLoading.value = false
    return errorHandle(error.response)
  })
}

function successDelete() {
  props.showFlash(i18n.global.t('pages.common.messages.removeSuccess'), "success", true)
  closeModal(true)
}

function changeFlashMessages(resultStatus = "", message = "") {
  flashMessage.type = resultStatus
  flashMessage.show = true
  flashMessage.cancel = false
  flashMessage.message = message

  if (resultStatus == "error") return flashMessage.cancel = true
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      changeFlashMessages("error", i18n.global.t('pages.common.messages.forbidden'))
      break
    default:
      changeFlashMessages("error", i18n.global.t('pages.common.messages.failedUpdate'))
      break
  }
}
</script>
<template>
  <GDialog
    v-model="modelValue"
    max-width="30%"
    transition="custom-from-bottom-transition"
    :persistent='true'
  >
    <ModalFlashMessage
      id="flash-message-component"
      :message = "flashMessage.message"
      :show = "flashMessage.show"
      :type = "flashMessage.type"
      :cancel = "flashMessage.cancel"
      @setShow = "(show) => {flashMessage.show = show}"
    />
    <div class="modal-header justify-content-center mt-2">
      <label class="confirmation-modal-title">
        {{ i18n.global.t('common.confirmationModal.title') }}
      </label>
    </div>
    <div class="modal-body mx-4 mt-2">
      <div class="confirmation-modal-note">
        {{ confirmMessage }}
      </div>
    </div>

    <div class="d-flex justify-content-end m-3 mt-4">
      <v-btn
        class="ma-2"
        :class="isLoading ? '' : 'reset-btn'"
        :style="{
          backgroundColor : isLoading ? '#B3B8BB' : ''
        }"
        @click="closeModal(false)"
        :disabled="isLoading"
      >
        {{ i18n.global.t('common.cancelBtn') }}
      </v-btn>
      <v-btn
        class="ma-2 exec-btn"
        @click="handleDelete"
        :loading="isLoading"
      >
        {{ i18n.global.t('pages.common.button.exec') }}
      </v-btn>
    </div>
  </GDialog>
</template>
